export default {
      id: "basket-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#basket",
      toString: function () {
        return this.url;
      }
    }